module.exports = __webpack_public_path__ + "static/Metropolis-Medium-66d573cf18bc7460a414fdb0ff4ade2e.woff";